// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__eykL8","social":"Socials_social__hA22P","social__link":"Socials_social__link__rrgjO"};